import { render } from "./organ.vue?vue&type=template&id=05eadc62&scoped=true"
import script from "./organ.vue?vue&type=script&lang=js"
export * from "./organ.vue?vue&type=script&lang=js"

import "./organ.vue?vue&type=style&index=0&id=05eadc62&scoped=true&lang=css"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05eadc62"]])

export default __exports__